import React from 'react'

const IconProgression = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.79167 8.23566V3.28857H5.21458V8.23566L4.50313 7.47587L3.79167 8.23566ZM7.51917 8.54003V0.288574H8.94208V7.11712L7.51917 8.54003ZM0.048125 11.9952V6.28857H1.47104V10.5721L0.048125 11.9952ZM0 14.7917L4.51917 10.21L6.51917 12.21L12.4375 6.2917H10.7115V5.20837H14.2948V8.7917H13.2115V7.04482L6.48708 13.79L4.48708 11.79L1.48542 14.7917H0Z" fill="#686867" />
    </svg>
  )
}

export default IconProgression;